import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Icon from '@material-ui/icons';
import IconItem from 'components/UI/IconTag';
import { getAdminMenuGroups } from 'utils/Constants';
import { map, filter, includes } from 'lodash';
import { defaultStyles } from 'utils/Theme';

const AdminMenuGroups = getAdminMenuGroups();

const AdminSideMenu = () => {
    const classes = defaultStyles();
    const match = useRouteMatch();
    const {
        isAuthenticated,
        user: { role },
    } = useSelector((state) => state.auth);

    return (
        <div>
            {!isAuthenticated && (
                <div>
                    <div className={'c-sidebar__title'}>My Account</div>
                    <ul className={'c-sidebar__list'}>
                        <li className={`c-sidebar__item `}>
                            <NavLink
                                to={'/Login'}
                                exact
                                className={'c-sidebar__link'}
                            >
                                <IconItem
                                    name={'Lock'}
                                    className={'u-mr-xsmall'}
                                />{' '}
                                Login
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )}

            {isAuthenticated &&
                map(
                    AdminMenuGroups,
                    ({ group, active, roles, menuItems, key }) =>
                        includes(roles, role) &&
                        active && (
                            <div key={key}>
                                <div className={'c-sidebar__title'}>
                                    {group}
                                </div>
                                <ul className={'c-sidebar__list'}>
                                    {map(
                                        menuItems,
                                        ({
                                            title,
                                            url,
                                            icon,
                                            roles,
                                            submenu,
                                            key,
                                        }) => {
                                            const IconTag =
                                                icon &&
                                                Icon[icon || 'ChevronRight'];
                                            const activeSubMenu = filter(
                                                submenu,
                                                (menu) => {
                                                    return (
                                                        menu.url.toLowerCase() ===
                                                        match.url.toLowerCase()
                                                    );
                                                }
                                            );
                                            const collapseChild =
                                                activeSubMenu[0] &&
                                                activeSubMenu[0].url;
                                            return (
                                                includes(roles, role) && (
                                                    <li
                                                        key={key}
                                                        className={`c-sidebar__item ${
                                                            submenu
                                                                ? 'has-submenu'
                                                                : ''
                                                        }`}
                                                    >
                                                        {submenu && (
                                                            <a
                                                                href={`#LinkItem_${key}`}
                                                                data-toggle={
                                                                    'collapse'
                                                                }
                                                                aria-expanded={
                                                                    'false'
                                                                }
                                                                aria-controls={
                                                                    'sidebar-submenu'
                                                                }
                                                                className={`c-sidebar__link ${
                                                                    collapseChild ===
                                                                        match.url &&
                                                                    classes.isActive +
                                                                        ' collapse is-active '
                                                                }`}
                                                            >
                                                                {icon && (
                                                                    <IconTag
                                                                        className={
                                                                            'u-mr-xsmall'
                                                                        }
                                                                    />
                                                                )}{' '}
                                                                {title}
                                                            </a>
                                                        )}

                                                        {!submenu && (
                                                            <NavLink
                                                                to={url}
                                                                exact
                                                                className={
                                                                    'c-sidebar__link'
                                                                }
                                                                activeClassName={`isActive ${classes.isActive}`}
                                                            >
                                                                {icon && (
                                                                    <IconTag
                                                                        className={
                                                                            'u-mr-xsmall'
                                                                        }
                                                                    />
                                                                )}{' '}
                                                                {title}
                                                            </NavLink>
                                                        )}
                                                        <div>
                                                            <ul
                                                                className={`c-sidebar__list collapse ${
                                                                    collapseChild ===
                                                                        match.url &&
                                                                    ' show is-active '
                                                                }`}
                                                                id={`LinkItem_${key}`}
                                                            >
                                                                {map(
                                                                    submenu,
                                                                    (
                                                                        {
                                                                            title,
                                                                            url,
                                                                        },
                                                                        index
                                                                    ) => (
                                                                        <li
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <NavLink
                                                                                exact
                                                                                activeClassName={`is-active ${classes.isActive}`}
                                                                                className="c-sidebar__link"
                                                                                to={
                                                                                    url
                                                                                }
                                                                            >
                                                                                {
                                                                                    title
                                                                                }
                                                                            </NavLink>
                                                                        </li>
                                                                    )
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </li>
                                                )
                                            );
                                        }
                                    )}
                                </ul>
                            </div>
                        )
                )}
        </div>
    );
};

AdminSideMenu.propTypes = {};

export default AdminSideMenu;
